import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UsePagesVisitReport() {
  const { enqueueSnackbar } = useSnackbar();
  const MyAxios = UseCustomAxios();

  const GetPageVisitReport = (search, type, myPC, bool, callback) => {
    MyAxios.get(`Admin_PageVisitReport/${type}?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetDailyPageVisitReport = (search, type, Date, myPC, callback) => {
    MyAxios.get(`Admin_PageVisitReport/${type}/${Date}?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetProductVisitCache = (callback) => {
    MyAxios.get(`Admin_PageVisitReport/SetAllProductVisitCache`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };
  const GetProductCache = (productID, callback) => {
    MyAxios.get(`Admin_PageVisitReport/SetProductVisitCache/${productID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const GetArticleVisitCache = (callback) => {
    MyAxios.get(`Admin_PageVisitReport/SetAllArticleVisitCache`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };
  const GetArticleCache = (articleID, callback) => {
    MyAxios.get(`Admin_PageVisitReport/SetArticleVisitCache/${articleID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    GetDailyPageVisitReport,
    GetPageVisitReport,
    GetProductVisitCache,
    GetArticleVisitCache,
    GetProductCache,
    GetArticleCache,
  };
}
